import { useEffect } from "react";
import classNames from "classnames/bind";
import { GalleryObject } from "@/components/Galleries/utils/utils.ts";
import { formatAmplienceImageURL } from "@JohnLewisPartnership/jl-design-system/dist/utils/imageUrlModifier/imageUrlModifier";
import styles from "./Thumbnails.module.scss";

const cx = classNames.bind(styles);

type ThumbnailProps = {
  media: GalleryObject[];
  selectedIndex: number;
  scrollImagesToIndex: (index: number) => void;
  autoScroll: boolean;
  ref: React.RefObject<HTMLDivElement | null>;
};

export const Thumbnails = ({
  ref,
  media,
  selectedIndex,
  scrollImagesToIndex,
  autoScroll,
}: ThumbnailProps) => {
  const scrollThumnailsToIndex = async (index: number) => {
    if (!ref.current) {
      return;
    }
    const target = ref.current.children[index];
    if (!(target instanceof HTMLElement)) return;

    ref.current.scrollTo(target.offsetLeft, target.offsetTop);
  };

  useEffect(() => {
    if (!autoScroll) {
      scrollThumnailsToIndex(selectedIndex);
    }
  }, [selectedIndex]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.thumbnails} ref={ref}>
        {media.map((mediaItem, ind) => (
          <div
            key={`${mediaItem.imageUrl}-${ind}`}
            className={cx(styles.thumbnailItem, {
              selected: ind === selectedIndex && !autoScroll,
            })}
          >
            <button
              className={cx(styles.thumbnailItemButton, {
                video: mediaItem.type === "video",
              })}
              onClick={() => {
                scrollImagesToIndex(ind);
                scrollThumnailsToIndex(ind);
              }}
              data-testid={`gallery:zoom:modal:thumbnails:thumbnail-${ind}`}
              aria-label={`Product Image ${ind + 1} of ${media.length}`}
            >
              <img
                src={formatAmplienceImageURL(
                  mediaItem.imageUrl + "?$rsp-pdp-port-320$",
                )}
                alt=""
                className={styles.thumbnailImage}
              />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
